var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "headphones",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M2.988,253.02H4.98a1,1,0,0,0,1-1V242a1,1,0,0,0-1-1H2.988A2.988,2.988,0,0,0,0,243.988v6.043A2.988,2.988,0,0,0,2.988,253.02Zm0,0",
    transform: "translate(0 -224.996)",
    fill: "#7dbaab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M199.992,241H198a1,1,0,0,0-1,1v12.02a1,1,0,0,1-1,1h-5.164a2.984,2.984,0,0,0-2.8-1.992h-4.051a2.988,2.988,0,1,0,0,5.977h4.051a2.984,2.984,0,0,0,2.8-1.992h5.164A2.992,2.992,0,0,0,199,254.016v-1h1a2.988,2.988,0,0,0,2.988-2.988v-6.043A2.988,2.988,0,0,0,199.992,241Zm0,0",
    transform: "translate(-168.98 -224.996)",
    fill: "#7dbaab"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M30.684,14.108a4.971,4.971,0,0,1,.951-.1h1.992a2.956,2.956,0,0,1,1.037.2,11.011,11.011,0,0,1,21.966,0,2.956,2.956,0,0,1,1.037-.2h1.992a4.971,4.971,0,0,1,.951.1,14.988,14.988,0,0,0-29.925,0Zm0,0",
    transform: "translate(-28.646)",
    fill: "#7dbaab"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.517b347dbe5f39476be261ee8d148fc5.svg";
export { ForwardRef as ReactComponent };